import React, { forwardRef } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';

/**
 * Number input that hides the browser's up/down arrows and prevents
 * the scroll wheel from changing the value when the field is focused.
 *
 * Drop-in replacement for `<Form.Control type="number" />`. Works with
 * Formik as `<Field as={NumberInput} />`.
 */
export const NumberInput = forwardRef<HTMLInputElement, FormControlProps>(
    ({ onWheel, onFocus, className, ...props }, ref) => {
        return (
            <Form.Control
                {...props}
                ref={ref}
                type="number"
                className={`no-number-spinner${className ? ` ${className}` : ''}`}
                onFocus={(e) => {
                    const input = e.target as HTMLInputElement;
                    if (input.value !== '' && Number(input.value) === 0) {
                        input.select();
                    }
                    onFocus?.(e);
                }}
                onWheel={(e) => {
                    (e.target as HTMLInputElement).blur();
                    onWheel?.(e);
                }}
            />
        );
    }
);

NumberInput.displayName = 'NumberInput';